export const DeactivateIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M56.6031 31.9023C56.6031 46.5878 44.6779 58.5002 30.0052 58.5002C15.3198 58.5002 3.39453 46.5751 3.39453 31.9023C3.39453 23.1296 7.62513 15.167 14.4566 10.2745C16.2249 9.0081 18.6885 10.2794 18.6885 12.4545V12.4576C18.6885 13.3203 18.2695 14.1267 17.5676 14.6284C11.7976 18.7524 8.3553 25.6077 8.75443 33.0726C9.34192 44.0603 18.464 52.8896 29.4639 53.1649C41.4304 53.4644 51.2617 43.8025 51.2617 31.9023C51.2617 24.9028 47.8969 18.5447 42.4541 14.6423C41.7535 14.14 41.3347 13.3346 41.3347 12.4725C41.3347 10.2966 43.8003 9.02523 45.5682 10.2937C52.3918 15.1894 56.6031 23.1365 56.6031 31.9023Z"
        fill="#FB3748"
      />
      <path
        d="M30.0047 24.8916C28.5242 24.8916 27.3398 23.7072 27.3398 22.2165V4.1955C27.3398 2.70481 28.5242 1.5 30.0047 1.5C31.4954 1.5 32.6798 2.6946 32.6798 4.1955V22.2165C32.6798 23.697 31.4852 24.8916 30.0047 24.8916Z"
        fill="#FB3748"
      />
    </svg>
  );
};
